// import Swiper JS
import Swiper, { Navigation, Pagination, Autoplay, Grid } from 'swiper'
import $ from 'jquery'

// configure Swiper to use modules
let tabContainer = document.querySelector('.tabbed-content__container')
let tabButtons = document.querySelectorAll('.tabbed-content__buttons')
let tabButton = document.querySelectorAll('.tab-button')
let tabContent = document.querySelectorAll('.tab-content')

const scrollIcon = document.querySelector('#icon-down-mouse')
const scrollLeftRightIcon = document.querySelector('.icon-scroll-left-right')

// first item is visible
if (tabContainer) {
  tabContent[0].classList.remove('hidden')
  tabButton[0].classList.add('selected')

  let tabButtonsWidth = 0
  tabButton.forEach(button => {
    tabButtonsWidth += button.getBoundingClientRect().width
  })

  if (tabButtonsWidth > tabContainer.getBoundingClientRect().width) {
    scrollLeftRightIcon.classList.remove('hidden')
  }

  const parent = tabContent[0].parentNode

  if (
    parent.getBoundingClientRect().height <
    tabContent[0].getBoundingClientRect().height
  ) {
    scrollIcon.classList.remove('hidden')
  } else {
    scrollIcon.classList.add('hidden')
  }

  if (tabButton) {
    tabButton.forEach(button => {
      button.addEventListener('click', function () {
        let buttonID = button.dataset.termId
        let buttonsGroup = tabContainer.querySelector('tabbed-content__buttons')

        tabButton.forEach(el => {
          el.classList.remove('selected')
        })

        button.classList.add('selected')

        tabContent.forEach(content => {
          let contentID = content.dataset.termId
          if (contentID === buttonID) {
            content.classList.remove('hidden')
            const parent = content.parentNode

            if (
              parent.getBoundingClientRect().height <
              content.getBoundingClientRect().height
            ) {
              scrollIcon.classList.remove('hidden')
            } else {
              scrollIcon.classList.add('hidden')
            }
          } else if (!content.classList.contains('remove')) {
            content.classList.add('hidden')
          }
        })
      })
    })
  }
}

function initHScroll () {
  let isDown = false
  let startX
  let scrollLeft

  const slider = document.querySelector('[data-scroll]')

  slider.addEventListener('mousedown', e => {
    isDown = true
    slider.classList.add('active')
    startX = e.pageX - slider.offsetLeft
    scrollLeft = slider.scrollLeft
  })
  slider.addEventListener('mouseleave', () => {
    isDown = false
    slider.classList.remove('active')
  })
  slider.addEventListener('mouseup', () => {
    isDown = false
    slider.classList.remove('active')
  })
  slider.addEventListener('mousemove', e => {
    if (!isDown) return
    e.preventDefault()
    const x = e.pageX - slider.offsetLeft
    const walk = (x - startX) * 3
    slider.scrollLeft = scrollLeft - walk
  })
}

// let modalFinitureBtn = document.getElementById('modal-finiture')

window.addEventListener('DOMContentLoaded', function () {
  let finishesCarouselContent = document.querySelectorAll('.tab-content')

  finishesCarouselContent.forEach(carousel => {
    let finishesCarousel = carousel.querySelector('.tabbed-content__slideshow')
    let finishesCarouselSlides = carousel.querySelectorAll('.swiper-slide')
    let currentSlide = finishesCarousel.querySelector('.current-slide')
    let totalSlides = finishesCarousel.querySelector('.total-slide')
  })

  initHScroll()
})
